import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  &.StatementsList {
    & .statements-container {
      margin-top: ${spacing(6)};
    }

    & .statements {
      display: flex;
      gap: 20px;
      flex-direction: column;
    }
  }
`
